import { defineAction, expression } from '~/prix'
import dashboardFetchAction from './dashboardFetch.action.json' with { type: 'json' }
import { z } from 'zod'
import { dashboardObject } from '../dashboardObject'

const dashboardFetchDefinition = defineAction({
  ...dashboardFetchAction,

  input: z.object({
    period: z
      .object({
        startDate: z.string().datetime(),
        endDate: z.string().datetime(),
      })
      .nullish(),
  }),
  output: z.object(dashboardObject),
})

export default dashboardFetchDefinition
